import React from "react";
import { useTranslation } from "react-i18next";

export default function UserDetailsComponent({ userInfo }) {
  const { t } = useTranslation();

  // ✅ Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    return date.toLocaleDateString("en-IN", {
      month: "short",   // Jan
      year: "numeric"   // 2026
    });
  };

  return (
    <div className="user-card">
      <div className="user-card__top">
        <div className="avatar">
          <span>👤</span>
        </div>

        <div className="user-info">
          <h3>{userInfo?.username}</h3>
          <p>{userInfo?.email}</p>
        </div>
      </div>

      <hr />

      <div className="user-card__bottom">
        <div className="info-row">
          <span className="label">{t("phone_label")}</span>
          <span className="value">{userInfo?.mobile_number}</span>
        </div>

        <div className="info-row">
          <span className="label">{t("member_since_label")}</span>
          <span className="value">
            {formatDate(userInfo?.date_joined)}
          </span>
        </div>
      </div>
    </div>
  );
}
